import { gql } from 'graphql-tag';
import { CURRENCY_FIELDS } from './Fragments';

export const GET_CURRENCIES = gql`
    query GetCurrencies {
        currencies {
            ...CurrencyFields
        }
    }
    ${CURRENCY_FIELDS},
`;

export default { GET_CURRENCIES };